import './index.css';

function EmptyData({title}){
  return (
    <>
      <div className="empty_data">
        <img src="./dashboard/not-found.svg" alt="" />
        <p><i>{title}</i></p>
      </div>
    </>
  );
}

export default EmptyData;